export const getCompetencyName = (competency, languageId, i18n = null) =>  {
    if (!competency) {
        return null;
    }

    // return alias
    if (languageId &&
        competency.competencyAliases &&
        competency.competencyAliases[languageId] &&
        competency.competencyAliases[languageId].name
    ) {
        return competency.competencyAliases[languageId].name;
    }

    // return API v2 alias
    if (languageId &&
        competency.aliases &&
        competency.aliases[languageId] &&
        competency.aliases[languageId].competencyAliasName
    ) {
        return competency.aliases[languageId].competencyAliasName;
    }

    // return translated label by translationKey
    if (i18n &&
        competency.translationKey &&
        i18n[`competencies_${competency.translationKey}`]
    ) {
        return i18n[`competencies_${competency.translationKey}`];
    }

    // return translated label by translationKeyName
    if (i18n &&
        competency.translationKeyName &&
        i18n[`competencies_${competency.translationKeyName}`]
    ) {
        return i18n[`competencies_${competency.translationKeyName}`];
    }

    // return untranslated name or label
    return competency.name || competency.label;
}
